import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { GameProvider, useGame } from './context/GameContext';
import { Toaster } from './components/ui/sonner';
import ResetButton from './components/ResetButton';
import Home from './pages/Home';
import Setup from './pages/Setup';
import NameEntry from './pages/NameEntry';
import GameRound from './pages/GameRound';
import Vote from './pages/Vote';
import Elimination from './pages/Elimination';
import MrWhiteGuess from './pages/MrWhiteGuess';
import Results from './pages/Results';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Contact from './pages/Contact';
import HowToPlay from './pages/HowToPlay';
import '@/App.css';

const GameRouter = ({ page, setPage }) => {
  const { gameState } = useGame();

  if (page === 'privacy') return <PrivacyPolicy onBack={() => setPage(null)} />;
  if (page === 'terms') return <TermsOfService onBack={() => setPage(null)} />;
  if (page === 'contact') return <Contact onBack={() => setPage(null)} />;
  if (page === 'howtoplay') return <HowToPlay onBack={() => setPage(null)} />;

  switch (gameState) {
    case 'home':
      return <Home setPage={setPage} />;
    case 'setup':
      return <Setup />;
    case 'nameEntry':
      return <NameEntry />;
    case 'gameRound':
      return <GameRound />;
    case 'vote':
      return <Vote />;
    case 'elimination':
      return <Elimination />;
    case 'mrWhiteGuess':
      return <MrWhiteGuess />;
    case 'results':
      return <Results />;
    default:
      return <Home setPage={setPage} />;
  }
};

function App() {
  const [page, setPage] = useState(null);

  return (
    <BrowserRouter>
      <GameProvider>
        <div className="App">
          <ResetButton />
          <GameRouter page={page} setPage={setPage} />
          <Toaster position="top-center" richColors />
        </div>
      </GameProvider>
    </BrowserRouter>
  );
}

export default App;
